export enum CARD_SPACING_VARIANT {
    DEFAULT = 'card-spacing-default',
    SMAll = 'card-spacing-small'
}
